import { Box } from "@material-ui/core";
import OtpInput from "react-otp-input";

import { useStyles } from "./InputOtp.style";

interface InputOtpProps {
  otp?: string;
  length: number;
  hasErrored?: boolean;

  onOtpChange?: (otp: string) => void;
}

export function InputOtp(props: InputOtpProps) {
  const classes = useStyles(props);
  // Props
  const { length, onOtpChange, otp, hasErrored } = props;

  return (
    <Box className={classes.root}>
      <OtpInput
        value={otp}
        onChange={onOtpChange}
        numInputs={length}
        hasErrored={hasErrored}
        shouldAutoFocus
        isInputNum
        containerStyle={classes.containerStyle}
        inputStyle={classes.inputStyle}
        focusStyle={classes.focusStyle}
        errorStyle={classes.errorStyle}
      />
    </Box>
  );
}

InputOtp.defaultProps = {
  hasErrored: false,
};
